import { ReactNode, createContext, useMemo, useState } from 'react';

interface ISegmentContext {
    isEditing: boolean;
    name: string;
    setName: (value: string) => void;
    setIsEditing: (value: boolean) => void;
}

const SegmentContext = createContext<ISegmentContext>({
    isEditing: false,
    name: '',
    setName: () => {},
    setIsEditing: () => {},
});

interface SegmentProviderProps {
    children: ReactNode;
}
const SegmentProvider = (props: SegmentProviderProps) => {
    const { children } = props;
    const [name, setName] = useState('');
    const [isEditing, setIsEditing] = useState(false);

    const ctx = useMemo(
        () => ({
            isEditing,
            name,
            setName,
            setIsEditing,
        }),
        [isEditing, name],
    );

    return <SegmentContext.Provider value={ctx}>{children}</SegmentContext.Provider>;
};

export { SegmentContext, SegmentProvider };
export type { ISegmentContext };
